// Voortgang van het invulscherm: welk deel van de vragenlijst is gehad?
//
// WAAROM KLEMMEN. Met conditionele vragen ligt het aantal stappen niet vast:
// een antwoord kan er vragen bij toveren. Stap 2 van 3 (67%) wordt dan stap 2
// van 4 (50%) en de balk springt terug. Een respondent die zichzelf achteruit
// ziet gaan, haakt af. Geklemd blijft elke tussenstand een echte breuk — de
// balk loopt alleen langzamer als de lijst groeit.
//
// Het totaal wordt om dezelfde reden op zijn hoogste stand gehouden: krimpt de
// lijst, dan zou de route achter de wandelaar worden afgesneden en denkt de
// gamification-balk dat het einde bereikt is.
//
// Klemmen gebeurt ALLEEN bij een vragenlijst met regels (`monotone`). Zonder
// regels ligt het totaal vast en moet de balk zich exact gedragen als altijd.
//
// AI-CONTEXT: See docs/features/conditional-questions.md

/**
 * @param {unknown} value
 * @param {number} fallback
 * @returns {number}
 */
const safeNumber = (value, fallback = 0) => (
    Number.isFinite(value) && value > 0 ? value : fallback
)

/**
 * @typedef {object} Progress
 * @property {number} ratio - Voortgang tussen 0 en 1
 * @property {number} percent - Diezelfde voortgang, afgerond op hele procenten
 * @property {number} total - Het aantal stappen om tegen af te zetten
 */

/**
 * @param {object} args
 * @param {number} args.stepIndex - Huidige stap, nul-gebaseerd
 * @param {number} args.visibleSteps - Aantal stappen dat nu zichtbaar is
 * @param {Progress} [args.previous] - De vorige uitkomst, om tegen te klemmen
 * @param {boolean} [args.monotone] - Klemmen? Alleen aan bij conditionele vragen
 * @returns {Progress}
 */
const questionnaireProgress = ({ stepIndex, visibleSteps, previous, monotone = false } = {}) => {
    const steps = safeNumber(visibleSteps)
    const index = safeNumber(stepIndex)

    const total = monotone ? Math.max(steps, safeNumber(previous?.total)) : steps
    const raw = total > 0 ? Math.min(index / total, 1) : 0
    const ratio = monotone ? Math.max(raw, safeNumber(previous?.ratio)) : raw

    return { ratio, percent: Math.round(ratio * 100), total }
}

export default questionnaireProgress
